<div class="loader-wrapper">
    <ev-logo-loader width="120px"></ev-logo-loader>
    <p>Vennligst vent...</p>
</div>